<!--  -->
<template>
  <div class="user" @mouseleave="showDropdown = false">
    <div class="user__default" v-if="!this.loginStatus" @click="showLoginSide">
        <img src="../assets/default-head.png" alt="">
    </div>
    <div v-else>
        <div  class="user__login" @click="toggleDropdown">
            <img src="../assets/test.png" alt="" v-if="loginType === 1">
            <img src="../assets/default-head-external.png" alt="" v-else>
            <span class="user__login__name" :style="setColorStyle">{{userInfo.username || userInfo.realName}}</span>
        </div>
        <transition name="fade">
            <div class="user__dropdown" v-show="showDropdown">
                <span @click="dialogVisible = true">退出</span>
            </div>
        </transition>
    </div>
   
    <transition name="fade">
        <div v-if="!loginStatus && shwoLoginBox && loginType === 2 || shwoLoginBox && currentVal === 'reg'">
          <CpLogin
            :showList="showList"
            :groups='groups'
            :requiredList="requiredList"
            :showExtItems="showExtItems"
            :requiredExtItems="requiredExtItems"
            @loginSucces="loginSucces"
            @loginClose="loginClose"
            @registClose='loginClose'
            @regSucces="regSucces"
            @serialSignUp='serialSignUp'
            :competitionId="competitionId"
            :color='globalConfig.vice'
            :tip="tip"
            :bgUrl='bgImg'
            :show="currentVal"
            :loginType='loginType'
            :userType='userType'
            :serialType='serialType'
          />
        </div>
        <!-- <Login
            v-if="shwoLoginBox && loginType === 1"
            @closeLoginMessageBox="closeLoginMessageBox"
        /> -->
        <Login
            v-if="!loginStatus && shwoLoginBox && loginType === 1"
            @showDeleteDialog="showDeleteBox = true"
            @successLogin="successLogin"
            @closeLoginMessageBox="closeLoginMessageBox"
            @changeLoginStatus='changeLoginStatus'
        />
        <reset-pwd @closeResetMessageBox="closeResetMessageBox" v-if="showRestPwdModal" />
    </transition>
    <xh-dialog
      title="退出登录"
      :visible.sync="dialogVisible"
      width="30%"
      category='quit'
      @quit="handleLoginOut"
      center
    >
      <span>您确定要退出登录吗？</span>
    </xh-dialog>
    <SignUpSuccess :dialogVisible.sync='dialogSignUpSuccessVisible' :onSuccess='onKnowSuccess'></SignUpSuccess>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
// import { getPathNameUrl } from '@/utils/query-string.js'
import Login from '../components/Login/Login';
import ResetPwd from '../components/Login/ResetPwd.vue';
import SignUpSuccess from './SignUpSuccess'
import { errorHandler } from '@/utils/errorHandler';
import { getRegInfo,serialSignUp } from '../services/user';
import {insideRegister } from '../services/home'
import { requiredList,showList } from '@/utils/constant.js'
export default {
  components: {
      Login,
      ResetPwd,
      SignUpSuccess
  },
  data () {
    return {
        showDropdown: false,
        shwoLoginBox: false,
        showRestPwdModal: false,
        dialogVisible:false,
        data:{},
        url:"",
        isHover:false,
        isShow:true,
        dialogSignUpSuccessVisible:false,
        currentVal:'login',
        currentRegInfo:{},
        currentName:''
        
    };
  },
  watch:{
      // certificateObj(newVal){
      //   if(newVal && newVal.bgUrl) this.setCertificateUrl();
        
      // }
    async isUserDiaLog(newVal){
      this.currentVal = newVal.currentVal
      newVal.isShowDiaLog && this.currentVal === 'reg' && this.currentName !== 'matchList' && await this.getCurrentRegInfo()
      newVal.isShowDiaLog && this.showLoginSide()
    },
    // isInsidSignUp:{
    //   handler() {
    //     if(this.loginStatus && this.loginType === 1 || this.loginStatus && this.isSerial){
    //       this.isRegister()
    //     }
    //   },
    //   immediate: true
    // },
  },
  computed: {
    ...mapGetters([
        'loginStatus',
    ]),
    ...mapState({
        userInfo: state => state.user.userInfo,
        bgImg:state => state.user.bgImg,
        certificateObj:state => state.certificate.info,
        competitionId: state => state.router.id,
        globalConfig: state => state.router.globalConfig,
        loginType: state => state.router.loginType,
        isUserDiaLog:state => state.user.isUserDiaLog,
        isSerialDiaLog:state=>state.user.isSerialDiaLog,
        isSerial:state=>state.router.isSerial,
        serialType:state=>state.user.serialType,
    }),
    showList() {
      if(this.isSerialDiaLog && this.currentVal === 'reg') return showList;
      const { showItems } = this.currentRegInfo;
      if ( showItems) {
        return JSON.parse(showItems)
      }
      return [];
    },
    setColorStyle(){
      return{
        color:this.globalConfig.main,
      }
    },
    requiredList() {
      if(this.isSerialDiaLog && this.currentVal === 'reg') return requiredList;
      const { requiredItems } = this.currentRegInfo;
      if (requiredItems) {
        return JSON.parse(requiredItems)
      }
      return [];
    },
    groups() {
      const { groups } = this.currentRegInfo;
      if ( groups) {
        return groups
      }
      return [];
    },
    showExtItems() {
      const { extItems } = this.currentRegInfo;
      if ( extItems) {
        return JSON.parse(extItems).filter(item => item.isShow)
      }
      return [];
    },
    requiredExtItems() {
      const { extItems } = this.currentRegInfo;
      if ( extItems) {
        return JSON.parse(extItems).filter(item => item.required)
      }
      return [];
    },
    tip() {
      const { tip } = this.currentRegInfo;
      if ( tip) {
        return tip
      }
      return '';
    },
    userType(){
      if(this.isSerialDiaLog || this.isSerial) return 'serial';
      return 'reg'
    }
  },

  mounted() {
    this.isShow = false;
    this.currentName = this.$route.name;
    // setTimeout(() => {
    //   this.isShow = true; 
    //   this.setCertificateUrl() 
    // }, 1);
  },

  methods: {
    ...mapActions('certificate',['certificateInit']),
    ...mapActions(['setUserDiaLog','setIsSerialDiaLog']),
    async getCurrentRegInfo(){
      const res = await getRegInfo(this.competitionId)
      this.currentRegInfo = res.data;
    },
      async insideRegister(info){
      try {
         let {status} = await insideRegister(info);
        if(status === 200){
          if(this.loginStatus){
              // this.$store.dispatch('saveUserInfo',{data})
              this.dialogSignUpSuccessVisible = true;
            }
        }
      } catch ({ data }) {
        errorHandler(data);
      }
     
    },
    // 系列赛 + 报名
    async serialSignUp(info){
      try {
        let { status } = await serialSignUp(info)
        if(status === 200) {
          this.loginClose()
          this.dialogSignUpSuccessVisible = true;
        }
      } catch (error) {
        this.$message.showMessage({info: error.data.message})
        this.loginClose()
      }
    },
    regSucces(data) {
      if(this.loginType === 1) this.insideRegister(data)
      if(this.loginType === 2) this.$store.dispatch('saveUserInfo', data)
      this.shwoLoginBox = false;
      this.setUserDiaLog({isShowDiaLog:false})
      // if(getPathNameUrl() && getPathNameUrl().includes('noc')) return this.setSmsSend(true)
      this.setIsSerialDiaLog(false)
    },
    onKnowSuccess(){
      this.$store.dispatch('setInsidSignUp', true)
      // setTimeout(() => {
      //   // window.location.reload()
      //   this.$store.dispatch('setInsidSignUp', true)
      // },500);
    },
    successLogin(data){
      this.$store
        .dispatch('saveUserInfo', data.data)
        setTimeout(() => {
            this.shwoLoginBox = false
            this.setUserDiaLog({isShowDiaLog:false})
        }, 1000)
    },
    closeLoginMessageBox(bol){
    if (bol) {
        this.showRestPwdModal = bol;
      }
      this.shwoLoginBox = false;
      this.setUserDiaLog({isShowDiaLog:false})
    },
    changeLoginStatus(){

    },
    // setCertificateUrl(){
    //     let buttons = this.certificateObj.buttons || [];
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.data = buttons.filter(item=>{
    //         return item.name === 'certificate_nav'
    //     })
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     return this.url = this.data ? (this.isHover ? this.setUrl(this.data[0].hoverUrl) : this.setUrl(this.data[0].url)) : '';
    //  },
    showLoginSide(){
      this.shwoLoginBox = true;
      // this.setUserDiaLog(true)
    },
    // getUrl(isHover){
    //     this.isHover = isHover;
    //     this.setCertificateUrl()
    // },
    // setUrl(url){
    //     return `http://cdn.xiaohoucode.com/${url}` || ''
    // },

    toggleDropdown() {
        this.showDropdown = !this.showDropdown
    },
    closeResetMessageBox(bol) {
      if (bol) {
        this.shwoLoginBox = bol;
      }
      this.showRestPwdModal = false;
      this.setUserDiaLog({isShowDiaLog:false})
    },
    handleLoginOut() {
        this.showDropdown = false;
        this.dialogVisible = false;
        this.$store.dispatch('LogOut');
    },
    enterFlow() {
      this.$router.push({
          path: '/cpFlow'
      })
    },
    loginClose() {
        this.shwoLoginBox = false
        this.setUserDiaLog({isShowDiaLog:false})
        this.setIsSerialDiaLog(false)
    },
    loginSucces(data) {
      this.$store
        .dispatch('saveUserInfo', data)
        setTimeout(() => {
            this.shwoLoginBox = false
            this.setUserDiaLog({isShowDiaLog:false})
        }, 1000)
        this.setIsSerialDiaLog(false)
    }
  },
}

</script>
<style lang='less' scoped>
.user {
    position: absolute;
    top: 5px;
    right: 40px;
    z-index: 100;
    display: flex;
    margin-left:10px;
    .certificate{
        height: 24px;
        width: 100px;
        text-align: center;
        font-size: 14px;
        line-height: 24px;
        font-weight: 500;
        background-size: 100%;
        background-position:center;
        background-repeat: no-repeat;
        border-radius:16px;
        cursor: pointer;
        margin-right:10px;
        margin-top:8px;

    }
    &__default {
        text-align: center;
        img {
            width: 35px;
            height: 35px;
        }
        &:hover {
            cursor: pointer;
        }
    }
    &__login {
        display: flex;
        align-items: center;
        text-align: center;
        min-width: 84px;
        img {
          width: 35px;
          height: 35px;
        }
        span {
          display: block;
        }
        &:hover {
          cursor: pointer;
        }
        &__name {
          margin-left: 20px;
          font-size:15px;
          font-family:PingFang SC;
          font-weight:500;
          color:rgba(107,76,46,1);
          max-width: 118px;
          overflow: hidden;/*超出部分隐藏*/
          text-overflow:ellipsis;/* 超出部分显示省略号 */
          white-space: nowrap;/*规定段落中的文本不进行换行 */

        }
    }
    &__dropdown {
        margin-top: 10px;
        span {
          margin: 0 auto 7px;
          display: block;
          width:84px;
          height:31px;
          line-height: 31px;
          font-size:15px;
          font-family:PingFang SC;
          font-weight:500;
          color:rgba(107,76,46,1);
          text-align: center;
          background:rgba(254,231,183,1);
          border-radius:16px;
        }
        &:hover {
            cursor: pointer;
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}
</style>